module.exports = __webpack_public_path__ + "static/shine-on-6903343f359c3d01b09ace1154ea1a3f.jpg";